



















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { MailCallbackRequestForUserPrompt, AddProfilesMailCallbackParams, AddProfilesMailCallbackValidationResults } from "@/dto/mail/callback/MailCallback";
import MailCallbackService from "@/services/MailCallbackService";
import PortalCheckbox from "@/components/new_style_components/PortalCheckbox.vue";

@Component({
  components: { PortalCheckbox }
})
export default class AddProfilesMailCallback extends Vue {
  @Prop({ required: true }) token!: string;
  @Prop({ required: true }) requestData!: MailCallbackRequestForUserPrompt;

  termsOfServiceAccepted = false;
  privacyPolicyAccepted = false;
  consentForMarketing = false;
  processing = false;

  get params(): AddProfilesMailCallbackParams {
    return this.requestData.params || {} as any;
  }

  get validationResults(): AddProfilesMailCallbackValidationResults {
    return this.requestData.validationResults || {} as any;
  }

  get priceIsActual(): boolean {
    return this.validationResults.priceIsActual === true;
  }

  get currentSubtotalCents(): number {
    return this.priceIsActual ? this.params.subtotalCents : this.validationResults.actualSubtotalCents;
  }

  get currentTaxCents(): number {
    return this.priceIsActual ? this.params.taxCents : this.validationResults.actualTaxCents;
  }

  get currentRecurringTotalCents(): number {
    return this.priceIsActual ? this.params.recurringTotalCents : this.validationResults.actualRecurringTotalCents;
  }

  formatCurrency(cents: number): string {
    return `$${(cents / 100).toFixed(2)}`;
  }

  get entitiesText(): string {
    const personName = this.$t('subscriptions.callback.entities.person_name_placeholder').toString();
    const companiesNames = (this.params.companies || []).join(', ');
    const hasPerson = this.params.hasPersonProfile;

    if (hasPerson && companiesNames) {
      return this.$t('subscriptions.callback.add_profiles.entities.both', { person: personName, companies: companiesNames }).toString();
    } else if (hasPerson) {
      return this.$t('subscriptions.callback.add_profiles.entities.person_only', { person: personName }).toString();
    } else {
      return this.$t('subscriptions.callback.add_profiles.entities.companies_only', { companies: companiesNames }).toString();
    }
  }

  get messageOptions() {
    return {
      entities: this.entitiesText,
      price: this.formatCurrency(this.currentSubtotalCents),
      tax: this.formatCurrency(this.currentTaxCents)
    };
  }

  async accept() {
    const isValid = await this.$validator.validateAll();
    if (!isValid) {
      (this as any).$nts.error(this.$t("auth.policy_acceptance.validation_error") as string);
      return;
    }

    this.processing = true;
    (this as any).$loadOn();

    try {
      const response = await MailCallbackService.runCallbackAction(this.token, {
        params: {
          action: "accept",
          subtotalCents: this.currentSubtotalCents,
          taxCents: this.currentTaxCents,
          termsOfServiceAccepted: this.termsOfServiceAccepted,
          privacyPolicyAccepted: this.privacyPolicyAccepted,
          consentForMarketing: this.consentForMarketing
        }
      });

      const params = response.data.params;
      if (params && params.approveLink) {
        this.$emit('success', params.approveLink);
      } else {
        (this as any).$nts.error("No approval link received from the server.");
      }
    } catch (e: any) {
      (this as any).$nts.error(e.response?.data?.message || "An error occurred.");
    } finally {
      this.processing = false;
      (this as any).$loadOff();
    }
  }
}
